<template>
    <tr>
        <td>
            {{ converter.name }}
        </td>
        <td>
            <router-link
            :to="{name: 'edit_converter', params: {id: converter.id}}"
            class="ui basic primary button"
            >
                內容
            </router-link>
            <button class="ui basic negative button" @click.prevent="delete_converter()">
                {{ $t('ui.general.delete') }}
            </button>
        </td>
    </tr>
</template>

<script>
export default {
    props: {
        converter: Object
    },
    data: function () {
        return {
            is_processing: false,
        }
    },
    computed: {
        delete_converter_url: function() {
            return this.$store.state.admin.converters_module.admin_converters_routes.delete;
        }
    },
    created: function() {
    },
    mounted: function() {
    },
    watch: {
    },
    methods: {
        delete_converter: function() {
            if (confirm(this.$t('ui.notifications.warning.are_you_sure_to_delete_it'))) {
                var that = this;
                that.is_processing = true;
                var url = new RestUrl(that.delete_converter_url).parse(
                    {"id": that.converter.id},
                    ""
                );

                axios.get(url).then(function (response) {
                    if (response.data.status == "success") {
                        that.$parent.init();
                        that.$noty.success("翻譯本刪除成功");
                    } else {
                        that.$noty.error("翻譯本刪除失敗");
                    }
                })
                .catch(function (error) {
                    if (!error.response) {
                        // Network Error
                        that.$noty.error(
                            that.$t('ui.general.network_abnormality')+": "+
                            that.$t('ui.general.server_offline')
                        );
                    } else {
                        that.$noty.error(that.$t('ui.general.network_abnormality')+': ' + error.response.status + error.response.data);
                    }
                });
                that.is_processing = false;
            }
        },
    },
    components: {
    }
}
</script>
